export default "__VITE_ASSET__8bTYZXz$__"